const DEFAULT_API_BASE_URL = (() => {
  if (import.meta.env.PROD) {
    return "https://zootel.shop/api/v1";
  }

  if (typeof window !== "undefined" && window.location.hostname) {
    return `${window.location.protocol}//${window.location.hostname}:4000/api/v1`;
  }

  return "http://localhost:4000/api/v1";
})();

export const API_BASE_URL = (
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE_URL) ||
  process.env.REACT_APP_API_BASE_URL ||
  DEFAULT_API_BASE_URL
).replace(/\/$/, "");

("API FILE LOADED");

const request = async (url, options = {}) => {
  const fullUrl = `${API_BASE_URL}${url}`;

  ("API request:", fullUrl);

  try {
    const response = await fetch(fullUrl, {
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
      ...options,
    });

    const contentType = response.headers.get("content-type");

    let data;

    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    if (!response.ok) {
      throw new Error(data?.error || `HTTP error ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error("API ERROR:", error);
    throw error;
  }
};

export const api = {
  get: (url) => request(url),

  post: (url, data) =>
    request(url, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  put: (url, data) =>
    request(url, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  delete: (url) =>
    request(url, {
      method: "DELETE",
    }),
};

// Alias
export const apiCall = api;
